import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Faq.module.scss";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
import { MdContactPhone, MdOutlineMail } from "react-icons/md";
import { RiPagesLine } from "react-icons/ri";

const Faq = () => {
  const { t } = useTranslation();
  const downloadManual = () => {
    window.open("https://hearing-space.com/hs-manual", "_blank");
  };

  const videoList = [
    { url: "https://www.youtube.com/embed/CA-OXasI1CE", title: t("faq.video_install") },
    { url: "https://www.youtube.com/embed/4sBqZDpN8Pk", title: t("faq.video_free_field") },
    { url: "https://www.youtube.com/embed/RQqMR2s5hos", title: t("faq.video_headphones") },
    { url: "https://www.youtube.com/embed/ZUtmdMd3VkI", title: t("faq.video_inserts") },
    { url: "https://www.youtube.com/embed/QUdhPwiYjrI", title: t("faq.video_free_field_install") },
    { url: "https://www.youtube.com/embed/PttdrPRYWik?si=r-_VH3Bbivk4QREt", title: t("faq.video_spatial") },
  ];

  return (
    <motion.div
      className={styles.container}
      variants={animatePage}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div className={styles.section}>
        <div className={styles.grid}>
          {/* CARTE 1 */}
          <div className={styles.card} onClick={downloadManual} style={{ cursor: "pointer" }}>
            <div className={styles.cardLink}>
              <RiPagesLine style={{ fontSize: 40 }} />
              <h3>{t("faq.manual_download")}</h3>
            </div>
          </div>

          {/* CARTE 2 */}
          <div className={styles.card}>
            <a className={styles.cardLink} href="tel:+33261720602">
              <MdContactPhone style={{ fontSize: 40 }} />
              <h3>{t("faq.phone_number")}</h3>
              <h4>{t("faq.phone_subtitle")}</h4>
            </a>
          </div>

          {/* CARTE 3 */}
          <div className={styles.card}>
            <a
              className={styles.cardLink}
              href="mailto:support@hearing-space.com"
            >
              <MdOutlineMail style={{ fontSize: 40 }} />
              <h3>{t("faq.email_address")}</h3>
              <h4>{t("faq.email_subtitle")}</h4>
            </a>
          </div>

          {/* VIDEOS */}
          {videoList.map((video, index) => (
            <div key={index} className={styles.card}>
              <iframe
                className={styles.media}
                src={video.url}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <div className={styles.cardTitle}>{video.title}</div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Faq;
